import { groupBy } from "lodash";
import { CheckboxGroup } from "@ww-digital/prism";
import { ChoiceButton } from "@ww-digital/web-foundations-react/modules";
import { isChecked, deleteAnswerById } from "../Question";
import { MULTISELECT_NONE_OF_THESE } from "config/tags";

import styles from "./styles.module.scss";

const MultiChoiceGroups = ({
  question,
  answers,
  handleAnswer,
  handleMultiChoiceOnChange,
  showNoneOfTheseCheckbox = false
}) => {
  const groups = groupBy(question.answers.presentationMetadata, a => a.tags[0]);

  return Object.keys(groups).map(group => {
    const checkboxesData = groups[group].map(option => ({
      label: option.text,
      id: option.id,
      tags: option.tags,
      checked: isChecked(option.id, answers)
    }));

    const showCheckbox =
      checkboxesData[0]?.tags?.includes(MULTISELECT_NONE_OF_THESE) &&
      showNoneOfTheseCheckbox;

    if (showCheckbox) {
      return (
        <ChoiceButton
          key={group}
          type="checkbox"
          className={styles.checkbox}
          id={checkboxesData[0].id}
          checked={checkboxesData[0].checked}
          title={checkboxesData[0].label}
          onChange={ev => {
            const checked = ev.target.checked;
            const answer = question.answers.presentationMetadata.find(
              a => a.id === checkboxesData[0].id
            );

            onChange(
              checked,
              answer,
              answers,
              handleAnswer,
              handleMultiChoiceOnChange
            );
          }}
        />
      );
    }

    return (
      <CheckboxGroup
        key={group}
        heading={group}
        checkboxesData={checkboxesData}
        onCheckedChange={(checked, id) => {
          const answer = question.answers.presentationMetadata.find(
            a => a.id === id
          );
          onChange(
            checked,
            answer,
            answers,
            handleAnswer,
            handleMultiChoiceOnChange
          );
        }}
        headingClassName={styles.heading}
        checkboxLabelClassName={styles.label}
        checkboxLabelSelectedClassName={styles.labelSelected}
        checkboxClassName={styles.checkbox}
        preset="pill"
      />
    );
  });
};

const onChange = (
  isAdding,
  selectedAnswer,
  answers,
  handleAnswer,
  handleMultiChoiceOnChange
) => {
  let filteredAnswers = [...answers];

  if (isAdding) {
    if (selectedAnswer.tags.includes(MULTISELECT_NONE_OF_THESE)) {
      filteredAnswers = [];
    } else {
      const noneOfTheseAnswer = filteredAnswers.find(a =>
        a.tags.includes(MULTISELECT_NONE_OF_THESE)
      );
      if (noneOfTheseAnswer) {
        filteredAnswers = deleteAnswerById(
          filteredAnswers,
          noneOfTheseAnswer.id
        );
      }
    }
    filteredAnswers.push(selectedAnswer);
  } else {
    filteredAnswers = deleteAnswerById(filteredAnswers, selectedAnswer.id);
  }

  handleAnswer(filteredAnswers);
  handleMultiChoiceOnChange(isAdding, selectedAnswer);
};

export default MultiChoiceGroups;
